import { Controller } from "@hotwired/stimulus";
import { format } from 'date-fns'

const dateFormat = (element) => {
  return element.value ? format(new Date(element.value), 'yyyy/MM/dd') : '';
}

export default class SectionsEditsFormNameSetterController extends Controller {
  static targets = [
    'nameDisplay',
    'nameField',
    'testDate',
    'testTime',
    'courseSubmissionStartDate',
    'courseSubmissionEndDate',
  ];
  
  static values = {
    courseName: String,
    dateFormat: String,
  };

  connect() {
    this.setName();
  }

  setName() {
    const newName = this.nameValues().filter(v => v?.length > 0).join(" ");

    this.nameDisplayTarget.textContent = newName;
    this.nameFieldTarget.value = newName;
  }

  nameValues() {
    switch (this.dateFormatValue) {
    case "testDate":
      return [
        this.courseNameValue,
        dateFormat(this.testDateTarget)
      ];
    case "testDateAndTime":
      return[
        this.courseNameValue,
        dateFormat(this.testDateTarget),
        this.testTimeTarget.selectedOptions[0].text,
      ];
    case "courseSubmissionDates":
      return [
        this.courseNameValue,
        [
          dateFormat(this.courseSubmissionStartDateTarget),
          dateFormat(this.courseSubmissionEndDateTarget),
        ].filter(v => v?.length > 0).join("ー")
      ];
    }
  }
}
